<template>
  <div class="modal-goodslist">
    <div class="modal">
      <div class="modal-header">
        <div style="padding: 6px;">房间类型添加</div>
        <button type="button" class="btn-close" @click="closeSelf">关闭</button>
      </div>
      <div class="modal-body">

        <el-form :model="addForm" :rules="rules" ref="addForm">
          <div>
            <el-row>
              <el-col :span="12" class="item">
                <el-form-item label="房间类型名称" required prop="name">
                  <el-input v-model="addForm.name" placeholder="请输入房间类型名称"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12" class="item">
                <el-form-item label="几人间" required prop="num">
                  <el-col :span="24">
                    <el-input-number v-model="addForm.num" :min='1'></el-input-number>
                  </el-col>
                </el-form-item>
              </el-col>
              <el-col :span="12" class="item">
                <el-form-item label="价格" required prop="price">元/{{chargeTime}}
                  <el-input type="number" v-model="addForm.price" placeholder="请输入价格"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>

        </el-form>

      </div>
      <div class="modal-footer">
        <el-button :loading="loading" type="primary" @click="confirm('addForm')">添加</el-button>
      </div>
    </div>
  </div>
</template>

<script>

import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffCode,getChargeTime} from "@/utils/auth";


export default {
  name: 'Add',
  props: ["buildingCodeValue"],
  data() {
    return {
      loading: false,
      floor:null,
      chargeTime:'',
      addForm:{
        timeStr:timeStr,
        sign:'',
        staffCode:getStaffCode(),
        name:'',
        num:'',
        price:''
      },
      floorValue:[],
      rules:{
        name:[
          { required: true, message: '请输入类型名称', trigger: 'blur' }
        ],
        num:[
          { required: true, message: '请输入几人间', trigger: 'blur' },
        ],
        price:[
          { required: true, message: '请输入金额', trigger: 'blur' },
          {
            pattern: /^([0-9]?)+(\.[0-9][0-9]?)?$/,
            message: "小数点后最多只能输入两位", trigger: 'blur'
          }
        ],
      }
    }
  },

  methods: {
    init(){
      this.$refs.addForm.resetFields();
      this.chargeTime = getChargeTime();
    },
    closeSelf() {
      this.$emit("closeAdd");
    },
    confirm(addForm){
      this.$refs[addForm].validate((valid) => {
        if(valid){
          if(this.addForm ==""){
            this.$message({type: 'info', message: '菜单不能为空'});
            return ;
          }
          this.addSubmit();
        }else {
          console.log('error submit!!');
          return false;
        }
      })

    },

    addSubmit(){
      if(this.loading){
        return;
      }else{
        this.loading = true;
      }
      this.addForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);
      this.$axios({
        method: 'post',
        url: this.$shopUrl+"RoomType/Add",
        data: this.addForm
      }).then(
          (response) => {
            this.loading = false;
            if (response.data.error == 0) {
              this.$emit("closeAdd");
              this.$emit("getList");
            }else if(response.data.error == 1){
              this.$message({type: 'info', message: response.data.message});
            }
          }
      )
    },


  }
}


</script>





<style lang="scss" scoped>

.modal-goodslist {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0,0,0,.3);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99;
  .modal {
    background-color: #fff;
    box-shadow:   0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
    overflow-x:auto;
    display: flex;
    flex-direction: column;
    border-radius: 10px;
    width: 600px;

    .modal-header {
      border-bottom: 1px solid #eee;
      color: #313131;
      justify-content: space-between;
      padding: 10px;
      display: flex;
    }
    .modal-body {
      position: relative;
      padding: 20px 0px;
      z-index: 99;
      height: 100%;
    }
    .modal-footer {
      border-top: 1px solid #eee;
      justify-content: flex-end;
      padding: 15px;
      display: flex;
    }


  }

}


.btn-close, .btn-confirm {
  border-radius: 8px;
  margin-left:16px;
  width:56px;
  height: 36px;
  border:none;
  cursor: pointer;
}
.btn-close {
  color: #313131;
  background-color:transparent;
}



.row{
  padding: 10px 0px;
}
.item{
  padding: 0px 20px;
}
.label{
  padding: 5px 0px;
}


</style>
